module.exports = __webpack_public_path__ + "assets/img/ic-recovery-hover.9d82513a.svg";